import { useQuery as I, useQueryClient as R } from "@tanstack/react-query";
import { useAuthStore as b, selectCurrentUserId as k } from "@waitroom/auth";
import { integrationsApiService as T } from "@waitroom/common-api";
import { STORAGE_LAST_USED_INTEGRATION as l } from "@waitroom/models";
import { CACHE_KEY_INTEGRATIONS_CONNECTIONS as L, activeOptions as M, emptyCacheKey as w, useQueryData as x, getRequestData as H, CACHE_KEY_INTEGRATIONS_GET_ACTION as Y } from "@waitroom/react-query";
import { useMemo as E, useCallback as n, useState as A, useEffect as j } from "react";
import { config as h } from "../config/index.es.js";
import { findLastUsedIntegrationProvider as z } from "../helpers/integrations.es.js";
const C = (e) => [
  L,
  e
], B = ({ userId: e, enabled: t }) => I({
  queryKey: t && e ? C(e) : w,
  queryFn: () => T.getConnections(),
  enabled: !!t && !!e,
  ...M["5m"],
  staleTime: 2500
  // use 2.5s because it can refetch in 3sec interval
}), se = (e) => {
  const t = E(() => C(e), [e]);
  return x(t);
}, J = (e) => {
  const t = R(), r = n(() => new Promise((m) => {
    setTimeout(async () => {
      await t.refetchQueries({
        queryKey: C(e),
        exact: !0
      }), m(!0);
    }, 3500);
  }), [t, e]), u = n(() => r(), [r]), d = n(() => r(), [r]);
  return {
    onConnect: u,
    onDisconnect: d
  };
}, re = ({ isEnabled: e = !0 }) => {
  var y, v;
  const t = b(k), r = !!t && e, {
    data: u,
    isSuccess: d,
    error: m,
    isLoading: N,
    refetch: G
  } = B({ userId: t, enabled: r }), i = H(u), c = h.storage.getParsed(
    l
  ), a = n(
    (s) => h.storage.set(l, s),
    []
  );
  E(() => {
    !i || !c || z(c, i) || a(void 0);
  }, [i, c, a]);
  const [o, _] = A(), [g, F] = A(), {
    data: S,
    isSuccess: K,
    isFetching: q,
    refetch: f
  } = I({
    queryKey: [
      Y,
      g,
      o == null ? void 0 : o.providerName,
      o == null ? void 0 : o.actionName
    ],
    queryFn: ({ queryKey: s }) => {
      const [, D, U = "", Q = ""] = s;
      return T.getAction(String(U), String(Q), {
        params: { aiFeedItemId: D }
      });
    },
    enabled: !1
  }), O = n(
    (s) => {
      _(s), a(s), F(s.aiSessionFeedMessageId);
    },
    [a]
  );
  j(() => {
    o && f();
  }, [o, f]);
  const { onConnect: p } = J(t), P = n(() => p(), [p]);
  return {
    providerCategories: i,
    errorProviderCategories: m,
    isFetchingProviderCategories: N,
    isSuccessProviderCategories: d,
    selectedIntegration: o,
    lastUsedIntegration: c,
    onClickProvider: O,
    onClickConnect: P,
    blockKitSchema: !!S && K && ((v = (y = S.data) == null ? void 0 : y.data) == null ? void 0 : v.schema) || void 0,
    isFetchingGetAction: q,
    selectedSessionFeedMessageId: g,
    refetchProviderCategories: G
  };
};
export {
  C as getConnectionsQueryKey,
  B as useGetConnections,
  se as useGetConnectionsData,
  re as useIntegrations,
  J as useUpdateGetConnectionsData
};
